/* mf-face.js — the gender lens's two DOM chores.
 *
 * The lens itself is not here. It is one CSS rule in the head of layout/theme.liquid
 * keyed on the html.mf-g-women / html.mf-g-men class that the pre-paint script stamps,
 * hiding .dcard[data-g="m"] and .dcard[data-g="w"] respectively. That is deliberately
 * all it is: the server sends one document to every visitor, nothing is personalised
 * behind a shared URL, and a card that does not belong to the face is never painted
 * once — no flash, no layout shift, and crawlers keep seeing the full catalogue.
 *
 * What CSS cannot do is the two things below.
 *
 * 1. THE HEADER OVERLAY'S "POPULAR CASES" ROW is sliced server-side by Liquid's
 *    `limit`, which runs before anything can be hidden. The snippet now asks for 8
 *    and this caps the row back to the first four the visitor can actually see.
 *
 * 2. THE THIN FACE. Some collections are curated one way round: /collections/cute is
 *    97% FOR HER, so the men's face lands on almost nothing. The auto-fill in
 *    collection-v2 tops the grid up, then gives up. When it does, say so and offer the
 *    way out, rather than leaving a short grid with no explanation. The step is fired
 *    once per pageview so the merchant can see which collections need the opt-out
 *    (Theme settings > Kollekció-szűrősáv > mf_nolens_collections) or a tagging pass.
 *
 * 2026-09-17 review: and one thing the head script cannot do - A PAGE BACK FROM THE
 * BACK/FORWARD CACHE. It is restored as it was frozen, with the face it had, while the
 * mf_g cookie may have been changed on the page the visitor came back from. On such a
 * restore this adopts the cookie's face and announces it as mf:face-changed with
 * source 'pageshow' (listeners repaint to __mfFace(), and push no step for it).
 *
 * Nothing here rewrites a link, touches the URL, or writes storage (the pageshow resync
 * re-writes the mf_g cookie with the value it just read, through __mfSetFace).
 *
 * Words (port kit, user 2026-09-17): the strip's text is the store's mf.face.* locale
 * keys, read through mfT (snippets/mf-l10n.liquid), so this file is byte-identical on
 * every store. It builds no paths, so market subfolders need nothing here.
 */
(function () {
  'use strict';

  var W = window, D = document;
  if (W.Shopify && W.Shopify.designMode) { return; }

  function T(k) { return W.mfT ? W.mfT(k) : ''; }
  function face() { return (W.__mfFace ? W.__mfFace() : '') || ''; }
  function shows(el) { return !W.__mfGShow || W.__mfGShow(el); }
  function step(name) {
    try { if (W.mfTrackPush) { W.mfTrackPush('mf_nav_step', { mf_step: name }); } } catch (e) {}
  }

  /* ── 1. the overlay's popular row ─────────────────────────────────────────── */
  function capPopular() {
    var grid = D.querySelector('.glossy-search__grid');
    if (!grid) { return; }
    var kept = 0;
    [].forEach.call(grid.querySelectorAll('.dcard'), function (card) {
      if (!shows(card)) { return; }               /* the CSS rule already hid it */
      kept++;
      card.hidden = kept > 4;
    });
  }

  /* the overlay is populated and repopulated by glossy-search-block's own script;
     watch the grid rather than guessing at its open event */
  function watchPopular() {
    var grid = D.querySelector('.glossy-search__grid');
    if (!grid || !W.MutationObserver) { return; }
    var pending = false;
    new MutationObserver(function () {
      if (pending) { return; }
      pending = true;
      setTimeout(function () { pending = false; capPopular(); }, 40);
    }).observe(grid, { childList: true });
  }

  /* ── 2. the thin-face escape strip ────────────────────────────────────────── */
  /* 8 is the floor for an unfiltered grid. With a mood chip on it has to be higher:
     the measured worst realistic case, Cute on the men's face of iPhone 17 Pro Max, is
     nine products - it would slip under an 8 and the visitor would get a nine-card page
     with no explanation. Read from the URL each time, because the sidebar path changes
     the query string without a reload. */
  function thinFloor() {
    return /[?&]filter\.p\.tag=/.test(W.location.search) ? 12 : 8;
  }
  /* 2026-09-17 review: the strip is no longer latched - it follows the grid. It used to be
     built once and then stay, but collection-v2's auto-fill and feed top a thin first screen
     up AFTER the first check (live: /collections/iphone-18-pro-max, Dla niej, an in-place
     Best Seller switch - 4 cards, the strip, then 29 cards and the strip still there). Now it
     goes as soon as the visible count is back at or above the floor, comes back if the grid
     thins out again, and goes when the face is cleared. It sits BEFORE the grid, never inside
     it, so adding or removing it is no mutation the grid watcher hears: no loop. The step is
     still one per result set (the page, then each new grid a filter / view / sort swaps in),
     capped at three per pageview - a strip that comes back is not a new landing.
     strip: the bar on the page or null; dismissed: the visitor closed it (holds until a new
     grid or a new face); stepDue: this result set's step is not yet spent. */
  var strip = null, dismissed = false, stepDue = true, thinSteps = 0;

  function gridOf() {
    return D.querySelector('#search-product-list .product-list__inner') ||
           D.querySelector('[id^="collection-grid-"] .product-list__inner');
  }

  function visibleCount(inner) {
    return [].filter.call(inner.querySelectorAll('.dcard'), shows).length;
  }

  function surface() {
    return D.querySelector('#search-product-list') ? 'srch' : 'plp';
  }

  function dropStrip() {
    if (strip && strip.parentNode) { strip.parentNode.removeChild(strip); }
    strip = null;
  }

  function buildStrip(inner) {
    dropStrip();

    var bar = D.createElement('div');
    bar.className = 'mf-thin';
    bar.setAttribute('role', 'status');

    var txt = D.createElement('span');
    txt.className = 'mf-thin__txt';
    txt.textContent = T('face.thin');

    var btn = D.createElement('button');
    btn.type = 'button';
    btn.className = 'mf-thin__cta';
    btn.textContent = T('face.show_all');
    btn.addEventListener('click', function () {
      step('mnu:g_off');
      /* review C12: the drawer tab emits the same mnu:g_off - this one is the strip's */
      step('mnu:g_offstrip');
      if (W.__mfSetFace) { W.__mfSetFace(''); }
      W.location.reload();
    });

    var x = D.createElement('button');
    x.type = 'button';
    x.className = 'mf-thin__x';
    x.setAttribute('aria-label', T('face.close'));
    x.innerHTML = '&#10005;';
    x.addEventListener('click', function () {
      dismissed = true;
      if (bar.parentNode) { bar.parentNode.removeChild(bar); }
      if (strip === bar) { strip = null; }
    });

    bar.appendChild(txt);
    bar.appendChild(btn);
    bar.appendChild(x);
    inner.parentNode.insertBefore(bar, inner);
    strip = bar;
  }

  /* one pass, idempotent: the strip ends up present exactly when a face is on and the grid
     shows fewer cards than the floor. dropOnly (strictly true) may take a strip away but never
     adds one - the at-once pass of a face change, before the grid has been topped up. */
  function checkThin(dropOnly) {
    var inner = gridOf();
    if (!face() || !inner) { dropStrip(); return; }
    var shown = visibleCount(inner);
    /* 2026-09-17 review: the face hid nothing here (search results and lens-off collections carry no
       data-g) - a short grid is not a thin FACE, and the strip's CTA would wipe the face for nothing */
    if (shown >= thinFloor() || shown === inner.querySelectorAll('.dcard').length) { dropStrip(); return; }
    if (dropOnly === true || dismissed) { return; }
    if (strip && strip.parentNode && strip.parentNode === inner.parentNode) { return; }   /* already there */
    if (stepDue && thinSteps < 3) { thinSteps++; step(surface() + ':g_thin'); }
    stepDue = false;
    buildStrip(inner);
  }

  var thinObserver = null, watched = null, mainObserver = null;
  function observeGrid(inner) {
    if (thinObserver) { thinObserver.disconnect(); thinObserver = null; }
    watched = inner;
    if (!W.MutationObserver) { return; }
    var pending = false;
    /* 2026-09-17 review: no longer stands down once the strip is up - growth must reach it */
    thinObserver = new MutationObserver(function () {
      if (pending) { return; }
      pending = true;
      setTimeout(function () { pending = false; checkThin(); }, 600);
    });
    thinObserver.observe(inner, { childList: true });
  }

  function watchThin() {
    if (!face()) { return; }
    /* armed before the grid check: an empty-state page (no product-list) still gets its grid watched
       once the visitor removes the filter */
    watchMain();
    var inner = gridOf();
    if (!inner) { return; }
    observeGrid(inner);
    /* 2.5 s is past collection-v2's auto-fill first tick (600 ms) and its retries;
       the mutation watcher covers a slow one */
    setTimeout(checkThin, 2500);
  }

  /* The filter sidebar, the collection bar's views and sorting replace #facet-main's
     innerHTML wholesale (theme.js), which DETACHES the grid the observer was watching - the
     watcher goes silent on exactly the interaction that produces the thinnest grids.
     2026-09-17 review: this used to re-arm 300 ms after facet:criteria-changed, which is
     usually BEFORE the section fetch lands, so it re-armed on the outgoing grid and the new
     one went unwatched. #facet-main itself stays, and the swap is a childList change on it:
     follow that to the new grid, and let the strip (and its step) come again for the new
     result set. The old strip leaves with the old grid's subtree. The pass waits the same
     2.5 s as the first one: the swapped-in grid is the server's first page, and collection-v2's
     feed fills it from a fetch of its own - judged earlier, the strip would flash. */
  function watchMain() {
    var main = D.getElementById('facet-main');
    if (mainObserver || !main || !W.MutationObserver) { return; }
    mainObserver = new MutationObserver(function () {
      var inner = gridOf();
      if (!inner || inner === watched) { return; }
      observeGrid(inner);
      dismissed = false;
      stepDue = true;
      setTimeout(checkThin, 2500);
    });
    mainObserver.observe(main, { childList: true });
  }

  /* 2026-09-17 review: a face change in place (the drawer's Kinek tabs, the collection bar's
     chips) or from the back/forward cache. The popular row is re-capped for the new face, and
     the strip is re-judged for it: a strip the new face no longer needs goes at once, a new
     one waits for the grid watcher / the 2.5 s pass (collection-v2 tops the grid up for the
     new face first). A cleared face takes the strip away. Contract: repaint only - no
     __mfSetFace, no re-dispatch, and no step when source is 'pageshow'. A closed strip may
     come back only for a DIFFERENT face (the bar's chips announce a click on the face that
     is already on, too). */
  var seenFace = face();
  D.addEventListener('mf:face-changed', function (ev) {
    capPopular();
    var f = face();
    if (f !== seenFace) { seenFace = f; dismissed = false; }
    if (!f) { dropStrip(); return; }
    if (ev && ev.detail && ev.detail.source === 'pageshow') { stepDue = false; }
    watchThin();
    checkThin(true);
  });

  /* ── 3. back/forward cache (2026-09-17 review) ────────────────────────────── */
  /* Page A in the men's face, page B switches to the women's (cookie mf_g=women), Back:
     A comes back frozen as men. On a persisted pageshow read the cookie exactly as the head
     script does (a missing or unknown value is the unisex face) and, when it disagrees with
     the live face, adopt it and tell the page. */
  W.addEventListener('pageshow', function (ev) {
    if (!ev || !ev.persisted || !W.__mfSetFace) { return; }
    var v = '';
    try {
      var m = D.cookie.match(/(?:^|;\s*)mf_g=(women|men)(?:;|$)/);
      v = m ? m[1] : '';
    } catch (e) { return; }
    if (v === face()) { return; }
    W.__mfSetFace(v);
    try { D.dispatchEvent(new CustomEvent('mf:face-changed', { detail: { face: v, source: 'pageshow' } })); } catch (eC) {}
  });

  function boot() {
    capPopular();
    watchPopular();
    watchThin();
  }

  if (D.readyState === 'loading') { D.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
